import Vue from 'vue'
import App from './App.vue'
import store from "../store";
import router from './router';
import Global from '@/libs/global';
import '@/libs/directive'//自定义指令

// 通用样式
import "./style/common.scss";
import VueScroller from 'vue-scroller';
Vue.use(VueScroller )

Vue.config.productionTip = false;

// 引入echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;


Vue.use(Global)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//路由拦截
router.beforeEach((to, from, next) => {
  const userData=localStorage.getItem('userData')
	const usertype=localStorage.getItem('usertype')
  let pathWechat=window.location.href
	if(to.matched.length === 0)  next({ path: '/'})
  if(to.path.indexOf('login')==-1&&to.path.indexOf('findpwd')==-1&&pathWechat.indexOf('wechatLogin')==-1&&pathWechat.indexOf('weChatChat')==-1&&pathWechat.indexOf('custormTable')==-1&&pathWechat.indexOf('screenshotH5')==-1&&pathWechat.indexOf('dataSize')==-1&&pathWechat.indexOf('diagnosis')==-1){
    //未登录不是修改密码
    if(!userData||!localStorage.getItem('token')){
      console.log('没有登录信息')
      next({ path: '/'})
    }else{
      //已经登录
      next();
    }
  }else{
    next();
  }
});
router.afterEach((to,from)=>{
  if(to.path.indexOf('login')!=-1){
    localStorage.removeItem('userData');
    localStorage.removeItem('usertype');
    localStorage.removeItem('token');
  }
})
